<template>
  <AppHead :title="title" :description="description" />
  <div :class="cn('h-full md:flex gap-2', props.class)">
    <div
      v-if="minExtraLarge && $slots.sidebar"
      class="relative flex flex-col min-w-[280px] w-1/6"
    >
      <div class="absolute inset-0">
        <slot name="sidebar" />
      </div>
    </div>
    <div class="h-full flex flex-col grow md:w-5/6">
      <slot name="header" />
      <div class="h-full relative">
        <div
          v-if="$slots['active-filters']"
          class="h-[51px] md:h-[55px] flex flex-col items-center overflow-x-auto"
        >
          <slot name="active-filters" />
        </div>
        <div
          id="page-content"
          class="absolute inset-0 bg-tertiary overflow-y-auto"
          :class="{ 'top-[51px] md:top-[55px]': $slots['active-filters'] }"
        >
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import AppHead from "@/Components/AppHead.vue";
import { useBreakpoints } from "@/Composables/useBreakpoints";
import { cn } from "@/Utils/cn";

const props = defineProps({
  title: { type: String, required: false },
  description: { type: String, required: false },
  class: { type: null, required: false },
});

const { minExtraLarge } = useBreakpoints();
</script>
